/* eslint-disable @typescript-eslint/no-explicit-any */
import { getDestination } from '../../../../utils';
import { withErrorBoundary } from '../../../components';

import {
  CardTitle,
  // CardTruncatedTitle,
  CardWrapper,
  Gradient,
  LocationWrapper,
  StyledChevron,
  StyledDate,
  StyledImage,
  StyledLocation,
  TitleWrapper,
} from './Styled';

const heroOrImage = (item: any) => {
  if (item.hero) {
    return {
      altText: item.hero.image.altText,
      gatsbyImageData: item.hero.image.asset.gatsbyImageData,
      title: item.hero.image.title,
    };
  } else {
    return {
      altText: item.image.altText,
      gatsbyImageData: item.image.asset.gatsbyImageData,
      title: item.image.title,
    };
  }
};

const TopCard = ({ item }: { item: any }) => {
  const { title, id, cardLink, startDate, location, slug } = item;

  const image = heroOrImage(item);
  const originalDate = new Date(startDate);
  const formattedDate = `${originalDate.getDate()}/${originalDate.getMonth() + 1}/${originalDate.getFullYear()}`;

  return (
    <CardWrapper key={id} to={(slug || cardLink?.externalUrl) ?? getDestination(cardLink?.internalEntry)}>
      <LocationWrapper>
        {startDate && <StyledDate>{formattedDate}</StyledDate>}
        {location && <StyledLocation>{location?.title}</StyledLocation>}
      </LocationWrapper>
      <TitleWrapper>
        <CardTitle lines="3">{title}</CardTitle>
        {/*<CardTitleTruncated lines="3">{title}</CardTitleTruncated>*/}
        <StyledChevron />
      </TitleWrapper>
      <StyledImage alt={image?.altText ? image.altText : title} image={image?.gatsbyImageData} objectFit="cover" />
      <Gradient />
    </CardWrapper>
  );
};

export default withErrorBoundary(TopCard, { componentName: 'MosaicSectionModule/Topcard' });
